<ion-header [ngClass]="{ 'hide-header-mode': hideheader }">
    <ion-toolbar>
        <div class="header-container">
            <div class="header-first-row">
                <div class="header-group">
                    <div class="btn-back-menu" (click)="onBackMenu()"></div>

                    <div class="set-sport-type">
                        <img [src]="iconTitle" class="sport-type-img" />
                    </div>

                    <div class="select-activity">
                        <ion-select
                        class="select-activity"
                        [(ngModel)]="mode.name"
                        (ionChange)="changeMode($event)"
                        [multiple]="false"
                        >
                        <!-- interface="popover" -->
                        <ion-select-option *ngFor="let option of types" [value]="option.name">
                            {{ option.name }}
                        </ion-select-option>
                        </ion-select>
                    </div>
                </div>
                <div class="header-title-text">
                    <span>{{ mode.name }}</span>
                </div>
                <div>
                    <ion-button fill="clear" (click)="onConfigureModal()">
                        <ion-icon slot="icon-only" name="settings"></ion-icon>
                    </ion-button>
                </div>
            </div>
        </div>
    </ion-toolbar>
</ion-header>


<ion-content [fullscreen]="true" [scrollY]="false" [ngClass]="{'hide-content-mode': hideheader, 'not-premium': !isPremium }">
    <div class="map-block">
        <div #map id="maptracker" *ngIf="trackingService.options.google"></div>
        <div #map id="maptracker" class="leafletmap" *ngIf="!trackingService.options.google"></div>
    </div>
    <ion-grid class="content-block" [style.background-color]="bgColor">
        <ion-row *ngIf="warningMessage && !raceFinished">
            <ion-col size="12" class="centered small-lines">
                <span class="large-text">{{ 'GO_TO_STARTING_POINT' | translate }}</span>
            </ion-col>
            <hr class="white-line">
        </ion-row>
        <ion-row>
            <ion-col class="text-center small-lines" style="padding-bottom: 0;">
                <span class="weight-medium" [style.color]="color">{{'TOTAL_TIME' | translate }}</span>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col class="text-center small-lines" style="padding-top: 0;">
                <strong class="font-size-verylarge" [style.color]="color">
                    {{ getCurrentDuration()}}
                </strong>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col class="text-center small-lines">
                <span class="weight-medium" [style.color]="color">
                    {{ 'CONFIGURATOR_DISPLAY_DISTANCE' | translate | uppercase }}</span>
                <br>
                <strong class="font-size-extralarge" [style.color]="color">{{ getDeepDistance()
                    }}</strong>
                <br>
                <span class="weight-medium" [style.color]="color"
                    *ngIf="distanceUnit.KM == trackingService.options.distanceUnit">
                    KM
                </span>
                <span class="weight-medium" [style.color]="color"
                    *ngIf="distanceUnit.MILES == trackingService.options.distanceUnit">
                    {{ 'DISTANCE_UNIT_MILES' | translate | uppercase }}
                </span>
            </ion-col>
        </ion-row>
        <ion-row [style.background-color]="bgColor" style="margin-top: -16px;">
            <ion-col class="text-center small-lines" size="6">
                <span class="weight-medium" [style.color]="color">{{ 'CONFIGURATOR_DISPLAY_SPEED' |
                    translate |
                    uppercase }} </span>
                <br>

                <strong class="font-size-medium" *ngIf="view.average_pace" [style.color]="color">{{ view.average_pace
                    }}</strong>
                <strong class="font-size-medium" *ngIf="!view.average_pace" [style.color]="color">0</strong>

                <br>
                <span class="weight-medium" [style.color]="color"
                    *ngIf="distanceUnit.KM == trackingService.options.distanceUnit">MIN/KM</span>
                <span class="weight-medium" [style.color]="color"
                    *ngIf="distanceUnit.MILES == trackingService.options.distanceUnit">MIN/{{ 'MILES' | translate
                    }}</span>
            </ion-col>
            <ion-col class="text-center small-lines" size="6">
                <span class="weight-medium" [style.color]="color">{{ 'CONFIGURATOR_DISPLAY_SPEED' |
                    translate |
                    uppercase }}</span>
                <br>
                <strong class="font-size-medium" [style.color]="color">{{ getAvSpeed(view.average_speed) }}</strong>
                <br>
                <span class="weight-medium" [style.color]="color"
                    *ngIf="distanceUnit.KM == trackingService.options.distanceUnit">KM/H</span>
                <span class="weight-medium" [style.color]="color"
                    *ngIf="distanceUnit.MILES == trackingService.options.distanceUnit">{{ 'MILES' | translate
                    }}/H</span>
            </ion-col>
        </ion-row>

        <ion-row class="bottom-bar" style="margin-bottom: 6px" [style.background-color]="bgColor">
            <ion-col class="centered text-center" size="3">
                <ion-button  fill="outline" class="btn-circle circle-outline people-btn" (click)="openAddParticipansPage()">
                    <ion-icon slot="icon-only" name="people" [style.color]="colorIcon" [style.fill]="colorIcon"></ion-icon>
                </ion-button>
            </ion-col>
            <ion-col  size="6" class="flex-space text-center">
                <ion-button
                    *ngIf="!getStarted() && !raceFinished"
                    [style.--background]="color"
                    class="btn-circle scale-big colored round-big"
                    [disabled]="isPlayDisabled"
                    (click)="startTrack(true)"
                    >
                    <ion-icon
                        name="play"
                        [style.color]="bgColor"
                        [style.fill]="bgColor"
                        class="font-medium center-triangle"
                        slot="icon-only"
                    ></ion-icon>
                </ion-button>
                <ion-button
                    *ngIf="getStarted() && !raceFinished"
                    [style.--background]="color"
                    class="btn-circle round scale-big colored round-big"
                    (click)="stop(false)"
                    >
                    <ion-icon
                        name="pause"
                        [style.color]="bgColor"
                        [style.fill]="bgColor"
                        class="font-medium"
                        slot="icon-only"
                    ></ion-icon>
                </ion-button>
                <ion-button
                    *ngIf="(!hasDistance || appDetector.isHellaApp() || appDetector.isEventsApp()) && !raceFinished && stopAllowed"
                    [style.--background]="color"
                    [disabled]="isStopDisabled()"
                    class="btn-circle round scale-big colored round-big"
                 
                    (click)="fullStop(false)"
                    >
                    <ion-icon
                        slot="icon-only"
                        name="square"
                        [style.color]="bgColor"
                        [style.fill]="bgColor"
                        class="font-medium scale-square"
                    ></ion-icon>
                </ion-button>
                <ion-button 
                    *ngIf="raceFinished"
                    [style.--background]="color"
                    class="btn-circle round scale-big colored round-big" 
                    (click)="goToResultStatisticsPage()"
                    >
                    <ion-icon 
                        name="stats-chart"
                        [style.color]="colorIcon"
                        [style.fill]="colorIcon" 
                        slot="icon-only" 
                        class="font-medium"
                    ></ion-icon>
                </ion-button>
            </ion-col>
            <ion-col  class="centered text-center" size="3">
                <ion-button  class="btn-circle restart-track" (click)="restartTrack()">
                    <ion-icon
                        slot="icon-only"
                        [style.color]="colorIcon"
                        [style.fill]="colorIcon"
                        style="transform: scale(1.3);"
                        name="refresh-circle-outline">
                    </ion-icon>
                </ion-button>
            </ion-col>

        </ion-row>

        <ion-row *ngIf="appDetector.isHellaApp()" style="background-color: #002f5d;">
            <div style="height: 20px;"></div>
        </ion-row>

    </ion-grid>
</ion-content>